module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/5-3b33f4aac8d4455257c1a7f82b371021.jpg";